import { render, staticRenderFns } from "./RolesBody.vue?vue&type=template&id=c6406638&scoped=true&"
import script from "./RolesBody.vue?vue&type=script&lang=js&"
export * from "./RolesBody.vue?vue&type=script&lang=js&"
import style0 from "./RolesBody.vue?vue&type=style&index=0&id=c6406638&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6406638",
  null
  
)

export default component.exports